import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2992b79b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=2992b79b&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=2992b79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992b79b",
  null
  
)

export default component.exports